<template>
  <div>
    loading
  </div>
</template>

<script>
export default {
  name: 'loading',
  data () {
    return {
    }
  },
}
</script>


// WEBPACK FOOTER //
// src/page/loading.vue